import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLogOut, FiUser, FiArrowLeft } = FiIcons;

const AdminHeader = ({ title, showBack = false }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isAdmin');
    navigate('/admin');
  };

  return (
    <div className="bg-green-900 text-white shadow-lg p-4 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-4">
          <img 
            src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759845307731-logo%20adjusted.png" 
            alt="Bondeega Logo" 
            className="w-10 h-10 object-contain bg-white rounded-full p-1"
          />
          <h1 className="text-2xl font-bold">{title}</h1>
        </div>

        <div className="flex items-center gap-3">
          <div className="bg-green-800 px-4 py-2 rounded-lg flex items-center gap-2 border border-green-700">
            <SafeIcon icon={FiUser} className="w-5 h-5" />
            <span className="font-medium">Admin User</span>
          </div>

          {showBack && (
            <Link 
              to="/admin/dashboard"
              className="bg-gray-700 hover:bg-gray-600 px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
            >
              <SafeIcon icon={FiArrowLeft} className="w-4 h-4" />
              <span>Back to Dashboard</span>
            </Link>
          )}

          <button 
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg flex items-center gap-2 transition-colors font-medium shadow-md"
          >
            <SafeIcon icon={FiLogOut} className="w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;